export const navItems = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'cui-chart'
  },
  {
    name: 'Cadastro',
    url: '/cadastro',
    icon: 'icon-user-follow',
    badge: {
      variant: 'info',
      text: ''
    }
  },
  {
    name: 'Encaminhamento',
    url: '/encaminhar',
    icon: 'cui-calendar',
    badge: {
      variant: 'info',
    }
  },

  {
    name: 'Agenda',
    url: '/agenda',
    icon: 'cui-calendar',
    badge: {
      variant: 'info',
      text: ''
    }
  },
  {
    name: 'Prestador',
    url: '/prestador',
    icon: 'icon-flag',
    badge: {
      variant: 'info'
    }
  },
  {
    name: 'Enfermeira',
    url: '/enfermeira',
    icon: 'icon-user-female',
    badge: {
      variant: 'info'
    }
  },
  {
    name: 'Terceiro',
    url: '/terceiro',
    icon: 'icon-user-female',
    badge: {
      variant: 'info'
    }
  }
  ,{
    name: 'Empresa',
    url: '/empresa',
    icon: 'fa fa-table',
    badge: {
      variant: 'info',
      text: ''
    }
  }
  ,{
    name: 'Tabela de Referência',
    url: '/tabelaReferencia',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  },{
    name: 'Emails',
    url: '/email',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  },{
    name: 'Voucher',
    url: '/voucher',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  }
  ,{
    name: 'Notificação',
    url: '/notificacao',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  }/*,{
    name: 'Consulta extra enfermeira',
    url: '/consultaExtraEnfermeira',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  }*/,{
    name: 'Consulta extra administrador',
    url: '/consultaExtraAdministrador',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  }  
  //{
  //  name: 'Configuraçoes',
  //  url: '/configuracoes',
  //  icon: 'fa fa-table',
  //  badge: {
  //    variant: 'info'
  //  }
  //}  
];


/*
,{
    name: 'Consulta extra enfermeira',
    url: '/consultaExtraEnfermeira',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  },{
    name: 'Consulta extra administrador',
    url: '/consultaExtraAdministrador',
    icon: 'fa fa-table',
    badge: {
      variant: 'info'
    }
  }

*/